const Datatable = ({ csvData }) => {
  // const staticData = [
  //     { srNo: 1, meterId: 'MTR001', kWh: 250, date: 'October/2024' },
  //     { srNo: 2, meterId: 'MTR002', kWh: 300, date: 'October/2024' },
  //     { srNo: 3, meterId: 'MTR003', kWh: 150, date: 'October/2024' },
  //   ];
  return (
    <>
      <div className="data-table">
       { 
        csvData && csvData.length > 0 && <table>
          <thead>
            <tr>
              {Object.keys(csvData[0]).map((key, idx) => (
                <th key={idx}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {csvData.map((row, index) => (
              <tr key={index}>
                {Object.values(row).map((val, idx) => (
                  <td key={idx}>{val}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>}

      </div>
    </>
  )
}

export default Datatable


// import React from 'react';

// const Datatable = ({ csvData }) => {
//   return (
//     <>
//       <div className="card">
//         <div className="card-header">
//           <h3 className="card-title">Data Table</h3>
//         </div>
//         <div className="card-body">
//           {csvData && csvData.length > 0 && (
//             <div className="table-responsive">
//               <table className="table table-striped mb-0">
//                 <thead>
//                   <tr>
//                     {Object.keys(csvData[0]).map((key, idx) => (
//                       <th key={idx}>{key}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {csvData.map((row, index) => (
//                     <tr key={index}>
//                       {Object.values(row).map((val, idx) => (
//                         <td key={idx}>{val}</td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Datatable;
